import { CustomNode } from '../../../types';
import { modifyChannelIcon } from '../../../icons';

const DEFAULT_ICON = modifyChannelIcon;

export const modifyMessageTypeConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
